import type { UpdateChannelRequest } from '@pulsify/shared'

const HANDLE_MIN = 3
export const HANDLE_MAX = 30
const HANDLE_PATTERN = /^[a-z0-9_]{3,30}$/

export function isValidHandle(handle: string): boolean {
  return HANDLE_PATTERN.test(handle)
}

/** A handle suggested from the name, with room left for `suffix`. */
export function handleFrom(name: string, suffix = ''): string {
  const base = name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
  const padded = base.length >= HANDLE_MIN ? base : `profil_${base}`.replace(/_+$/, '')
  return `${padded.slice(0, HANDLE_MAX - suffix.length)}${suffix}`
}

export const randomSuffix = () => `_${Math.floor(100 + Math.random() * 900)}`

export function textOrNull(value: string): string | null {
  return value.trim() || null
}

export function namePatch(
  current: { handle: string },
  name: string,
  handle: string,
): UpdateChannelRequest {
  return { name: name.trim(), ...(handle === current.handle ? {} : { handle }) }
}

export function aboutPatch(description: string, descriptionEn: string): UpdateChannelRequest {
  return { description: textOrNull(description), descriptionEn: textOrNull(descriptionEn) }
}

export function linksPatch(website: string, instagram: string): UpdateChannelRequest {
  return { website: textOrNull(website), instagram: textOrNull(instagram) }
}
